module.exports = __webpack_public_path__ + "static/media/logo-mobile.936c7569.png";